var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-144.000000, -991.000000)","fill":"currentColor"},React.createElement("g",{"transform":"translate(144.000000, 908.000000)"},React.createElement("g",{"transform":"translate(0.000000, 82.000000)"},React.createElement("g",{"transform":"translate(17.000000, 5.000000) rotate(-90.000000) translate(-17.000000, -5.000000) translate(12.000000, -12.000000)"},React.createElement("ellipse",{"cx":"4.05970149","cy":"4.78947368","rx":"4.05970149","ry":"4.21052632"})))))));
}

Circle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 9 9","version":"1.1"};

module.exports = Circle;

Circle.default = Circle;
